import { NavLink, useNavigate } from 'react-router-dom'
import { logout } from '../services/auth'

function Navigation() {
  const navigate = useNavigate()

  const handleLogout = () => {
    logout()
    navigate('/login')
  }

  const navLinkClass = ({ isActive }: { isActive: boolean }) =>
    `relative px-4 py-2 text-sm font-semibold uppercase tracking-wider transition-all duration-300 ${
      isActive
        ? 'text-white'
        : 'text-[var(--chrome-200)] hover:text-[var(--energy-cyan)]'
    }`

  return (
    <nav className="glass-panel sticky top-0 z-50 border-x-0 border-t-0 rounded-none">
      {/* Top accent line */}
      <div className="absolute top-0 left-0 right-0 h-[2px] bg-gradient-to-r from-transparent via-[var(--energy-cyan)] to-transparent opacity-60" />
      
      {/* Scan line effect */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute w-full h-[1px] bg-gradient-to-r from-transparent via-[var(--energy-cyan)] to-transparent opacity-20 animate-[scan-line_8s_linear_infinite]" />
      </div>

      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          {/* Logo / Brand */}
          <div className="flex items-center gap-3">
            {/* Geometric Logo */}
            <div className="relative w-10 h-10 flex items-center justify-center">
              <div className="absolute inset-0 border-2 border-[var(--energy-cyan)] rotate-45 opacity-60" />
              <div className="absolute inset-2 border border-[var(--weave-400)] rotate-45 opacity-40" />
              <span className="text-[var(--energy-cyan)] font-bold text-lg z-10">I</span>
            </div>
            <div>
              <h1 className="text-xl font-bold tracking-wider bg-gradient-to-r from-[var(--energy-cyan)] to-[var(--weave-300)] bg-clip-text text-transparent">
                IDEAS
              </h1>
              <p className="text-[10px] text-[var(--chrome-400)] tracking-[0.2em] uppercase -mt-1">
                Ideaverse
              </p>
            </div>
          </div>

          {/* Navigation Links */}
          <div className="flex items-center gap-1">
            <NavLink to="/queue" className={navLinkClass}>
              {({ isActive }) => (
                <>
                  <span className="relative z-10">Queue</span>
                  {isActive && (
                    <span className="absolute bottom-0 left-1/2 -translate-x-1/2 w-8 h-[2px] bg-[var(--energy-cyan)] shadow-[0_0_10px_var(--energy-cyan)]" />
                  )}
                </>
              )}
            </NavLink>
            
            <NavLink to="/kanban" className={navLinkClass}>
              {({ isActive }) => (
                <>
                  <span className="relative z-10">Kanban</span>
                  {isActive && (
                    <span className="absolute bottom-0 left-1/2 -translate-x-1/2 w-8 h-[2px] bg-[var(--energy-cyan)] shadow-[0_0_10px_var(--energy-cyan)]" />
                  )}
                </>
              )}
            </NavLink>
            
            <NavLink to="/graph" className={navLinkClass}>
              {({ isActive }) => (
                <>
                  <span className="relative z-10">Graph</span>
                  {isActive && (
                    <span className="absolute bottom-0 left-1/2 -translate-x-1/2 w-8 h-[2px] bg-[var(--energy-cyan)] shadow-[0_0_10px_var(--energy-cyan)]" />
                  )}
                </>
              )}
            </NavLink>

            {/* Separator */}
            <div className="w-[1px] h-6 bg-gradient-to-b from-transparent via-[var(--glass-border)] to-transparent mx-3" />

            {/* Logout Button */}
            <button
              onClick={handleLogout}
              className="btn-ghost text-xs px-3 py-1.5 text-[var(--chrome-300)] hover:text-[var(--alert-coral)] hover:border-[var(--alert-coral)] hover:shadow-[0_0_15px_rgba(255,64,64,0.3)]"
            >
              Logout
            </button>
          </div>
        </div>
      </div>
    </nav>
  )
}

export default Navigation
